import * as stylex from "@stylexjs/stylex";
import { cloneElement, type ReactElement, type ReactNode } from "react";
import "../tokens.stylex.ts";
import { color, font, fontSize, fontWeight, media, motion, radius, space } from "../tokens.stylex.ts";
import { surface } from "./surface.styles.ts";
export interface NavItemProps {
  /** The link element to render, e.g. `<Link to="/acme/apps" />`. */
  render: ReactElement<{
    className?: string;
    children?: ReactNode;
    "aria-current"?: "page";
  }>;
  icon?: ReactNode;
  active?: boolean;
  children: ReactNode;
  trailing?: ReactNode;
}

/** Sidebar navigation entry. Router-agnostic: pass the router's link as `render`. */
export function NavItem({
  render,
  icon,
  active = false,
  children,
  trailing
}: NavItemProps) {
  return cloneElement(render, {
    "aria-current": active ? "page" : undefined,
    ...stylex.props(styles.item, active && surface.raised, active && surface.xs, active && styles.active),
    children: <>
        {icon ? <span {...{
        0: {
          className: "x78zum5 xxe3v3u"
        },
        1: {
          className: "x78zum5 x9aqtqa"
        }
      }[!!active << 0]}>{icon}</span> : null}
        <span className="x1iyjqo2 xeuugli xb3r6kr xlyipyv xuxw1ft">{children}</span>
        {trailing}
      </>
  });
}
export function NavSection({
  label,
  children
}: {
  label?: ReactNode;
  children: ReactNode;
}) {
  return <div className="x78zum5 xdt5ytf x12mrbbr">
      {label ? <div className="x1uu5im9 x2sz766 x18dy136 xxg9qwl xmccgnw x14axpdx xjat59b xxe3v3u">{label}</div> : null}
      {children}
    </div>;
}
const styles = {
  item: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "x1a62zme x1rcmy67",
    kZKoxP: "x1gnnpzl x8tjdam",
    kg3NbH: "x1uu5im9 x1g5qazo",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x9r1u3d",
    kaIpWk: "xoazux2",
    kGuDYH: "xluwven xcb8g08",
    k63SB2: "x1219144",
    kMwMTN: "x187ovcu x2f91i5",
    kWkggS: "xjbqb8w x1b8pnsr x1enuzbz",
    kybGjl: "x1hl2dhg",
    kfSwDN: "x87ps6o",
    k7VYTy: "xpdipgo",
    kI3sdo: "x1a2a7pz",
    kMeerF: "x1de99jn",
    k3XXqK: "x1t137rt x9v5kkp",
    kjBf7l: "x15xi569",
    kInvED: "x1y3gkto",
    k1ekBW: "xs2xxs2",
    kIyJzY: "x7updtu",
    $$css: true
  },
  active: {
    kMwMTN: "x9aqtqa",
    kWkggS: "xjbqb8w x1n5bzlp",
    $$css: true
  }
};
export interface TabNavItemProps {
  render: ReactElement<{
    className?: string;
    children?: ReactNode;
    "aria-current"?: "page";
  }>;
  active?: boolean;
  children: ReactNode;
}

/** Horizontal, link-based tabs for contextual page navigation. */
export function TabNav({
  children,
  "aria-label": label
}: {
  children: ReactNode;
  "aria-label": string;
}) {
  return <nav aria-label={label} className="x78zum5 x18w2rdc xtyru57 xso031l x1q0q8m5 x13szane x1uwj2lv x1o97avp xw2csxc x1tixhcp x1lavhwh x1rohswg x5lxg6s">
      {children}
    </nav>;
}
export function TabNavItem({
  render,
  active = false,
  children
}: TabNavItemProps) {
  return cloneElement(render, {
    "aria-current": active ? "page" : undefined,
    ...{
      0: {
        className: "x78zum5 x6s0dn4 x16wdlz0 x8tjdam x2lah0s x1jyxor1 xluwven x1219144 xxe3v3u x2f91i5 x1hl2dhg xuxw1ft xlxy82 x1q0q8m5 x16stqrj x1a2a7pz x9vm7n9"
      },
      1: {
        className: "x78zum5 x6s0dn4 x16wdlz0 x8tjdam x2lah0s x1jyxor1 xluwven x1219144 x1hl2dhg xuxw1ft xlxy82 x1q0q8m5 x1a2a7pz x9vm7n9 x9aqtqa xc8aav1"
      }
    }[!!active << 0],
    children
  });
}